import React, { useCallback } from 'react';

import { Modal, ModalDialogProps } from '@eika/modal';

import { globalCssNamespace } from '../../index';
import { OptionalType } from '../../types/OptionalType';

type EikaModalProps = {
    onSubmit?: () => void;
    ariaLabel?: string;
} & OptionalType<ModalDialogProps, 'appNamespace'>;

const EikaModal = React.forwardRef(
    (
        { appNamespace = globalCssNamespace, ariaLabel, onSubmit, ...rest }: EikaModalProps,
        ref?: React.Ref<HTMLDivElement>,
    ) => {
        const onKeyDown = useCallback(
            (event: React.KeyboardEvent<HTMLDivElement>) => {
                if (onSubmit && event.key === 'Enter') {
                    event.preventDefault();
                    onSubmit();
                }
            },
            [onSubmit],
        );
        return (
            <Modal
                appNamespace={appNamespace}
                aria-label={ariaLabel}
                onKeyDown={onSubmit ? onKeyDown : undefined}
                {...rest}
                ref={ref}
            />
        );
    },
);

export default EikaModal;
